import { JSX, ReactNode } from "react";
import { Link } from "react-router-dom";

import { IconCaretRight } from "@/components/icons";

import { cn } from "@/utils/cn.ts";

export interface SectionProps {
  title: string;
  link?: string;
  children: ReactNode;
  backUrl?: string;
  className?: string;
}

const Section = ({ title, link, children, className }: SectionProps): JSX.Element => {
  const titleElement = (
    <h2
      className={cn(
        "text-2xl font-semibold transition-colors group-hover/title:text-orange-1 max-md:text-xl max-md:leading-5",
      )}
      dangerouslySetInnerHTML={{ __html: title }}
    ></h2>
  );

  return (
    <section className={cn("flex flex-col gap-3 rounded-[1.875rem] px-0 py-4 max-lg:rounded-[1.25rem]", className)}>
      {title && !link && <>{titleElement}</>}
      {link && title && (
        <Link
          to={link}
          aria-label={title}
          className={"group/title flex items-center gap-2 transition-all hover:gap-[0.625rem] sm:w-max"}
        >
          {titleElement}
          <IconCaretRight
            className={"size-5 stroke-on-surface-variant transition-all group-hover/title:stroke-orange-1"}
          />
        </Link>
      )}
      {children}
    </section>
  );
};

export default Section;
